import React from 'react';
import { partners } from '../mock';

const PartnerLogo = ({ name }) => (
  <div className="flex-shrink-0 flex items-center justify-center h-16 px-8 min-w-[180px] rounded-2xl border border-white/[0.06] bg-[#0f0f0f] hover:border-[#D4A94F]/40 hover:bg-[#141414] btn-transition group">
    <span className="text-neutral-500 group-hover:text-[#E9C46A] font-semibold text-lg tracking-tight btn-transition whitespace-nowrap">
      {name}
    </span>
  </div>
);

const Partners = () => {
  const doubled = [...partners, ...partners];
  return (
    <section id="partners" className="relative py-24 lg:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mb-14 text-center">
        <div className="inline-block px-4 py-1.5 rounded-full border border-[#D4A94F]/30 bg-[#D4A94F]/5 mb-5">
          <span className="text-xs font-medium tracking-widest uppercase text-[#E9C46A]">
            Platform Distribusi
          </span>
        </div>
        <h2 className="text-white font-bold text-4xl md:text-5xl leading-tight tracking-tight">
          Dipercaya Oleh{' '}
          <span className="gold-gradient-text">20+ Platform</span>
        </h2>
        <p className="text-neutral-400 text-lg mt-4 max-w-2xl mx-auto">
          Musik Anda hadir di setiap platform digital music store terkemuka di seluruh dunia
        </p>
      </div>

      {/* Marquee row 1 */}
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0a0a0a] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0a0a0a] to-transparent z-10 pointer-events-none" />
        <div className="flex gap-4 animate-marquee w-max">
          {doubled.map((p, i) => (
            <PartnerLogo key={`${p.name}-${i}`} name={p.name} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
